import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useNotifications } from 'app/application/application'
import { useApi } from 'app/common/application'

import { EventsResponse } from '../types'

const useEvents = () => {
  const { read } = useApi()
  const { createNotification } = useNotifications()
  const { t } = useTranslation('error')

  const getEvents = useCallback(async () => {
    const result = await read<EventsResponse>('/client/v1/events')

    if (result.ok) {
      return result.val
    }

    createNotification({
      message: result.val.message,
      title: t(`http.${result.val.code}`),
      type: 'error',
    })

    return []
  }, [createNotification, read, t])

  return { getEvents }
}

export default useEvents
